'use strict';

const bindTargetNavigation = ($anchorElement, beforeScroll) => {
  if (!$anchorElement.length) {
    return;
  }

  const $target = $($anchorElement.attr('href'));
  const $stickyFooter = $('#sticky-footer.hybrid-footer');
  const $stickyDealHighlights = $('.deal-highlights.sticky-ums');

  if (!$target.length) {
    return;
  }

  const promise = $.Deferred();

  $anchorElement.on('click', e => {
    e.preventDefault();
    const stickyFooterHeight =
      $stickyFooter.hasClass('sticky') || $stickyFooter.length === 0
        ? 0
        : $stickyFooter.outerHeight();
    const stickyDealHighlightsHeight = $stickyDealHighlights.length
      ? $stickyDealHighlights.outerHeight()
      : 0;
    if (beforeScroll != null) {
      beforeScroll(promise);
    } else {
      promise.resolve();
    }

    return promise.done(() =>
      $('html, body').animate({
        scrollTop:
          Math.ceil($target.offset().top) -
          stickyFooterHeight -
          stickyDealHighlightsHeight,
      })
    );
  });
};

module.exports = bindTargetNavigation;
